import React from 'react';
import SvgIcon from './SvgIcon';

const Homicide = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M12 .5A9.5 9.5 0 002.5 10v7.5a2 2 0 002 2v2a2 2 0 002 2h11a2 2 0 002-2v-2a2 2 0 002-2V10A9.5 9.5 0 0012 .5v0zM12 23.5v-4M16 23.5v-4M8 23.5v-4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17 16.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM7 16.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM5.5 6.5v1a3 3 0 01-3 3M18.5 6.5v1a3 3 0 003 3M13 17.5a1 1 0 00-2 0"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Homicide.displayName = 'HomicideIcon';

export default Homicide;
